import React from "react";
import { __ } from '@wordpress/i18n';

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;

const Payment = ({ formValues, setFormValues }) => {
    const handleCurrencyChange = (e) => {
        setFormValues((prev) => ({ ...prev, currency: e.target.value }));
    };

    const handleFormatChange = (e) => {
        setFormValues((prev) => ({ ...prev, format: e.target.value }));
    };
    const handlePaymentMethodToggle = (e) => {
        const methodId = e.target.value;
        const isChecked = e.target.checked;

        setFormValues((prev) => {
            const current = Array.isArray(prev.payment_methods) ? prev.payment_methods : [];
            const updated = isChecked
                ? [...current, methodId]
                : current.filter((m) => m !== methodId);
            return { ...prev, payment_methods: updated };
        });
    };
    
    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
        >
            <h2 className='text-2xl font-inter text-ec-title font-medium mb-8'>{__('Payment Setup', 'easycommerce')}</h2>
            <div className="w-full">
                <div className="flex flex-col w-full space-y-6">
                    {/* Currency */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={formValues.currency}
                            name="payment-pricing-currency"
                            onChange={handleCurrencyChange}
                        >
                            <option value="">Select Your Currency</option>
                            {Object.keys(EASYCOMMERCE.currencies).map((currency) => (
                                <option key={currency} value={currency}>
                                    {EASYCOMMERCE.currencies[currency]}
                                </option>
                            ))}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency you want to use.
                        </p>
                    </div>

                    {/* Currency Format */}
                    <div className="flex flex-col space-y-2">
                        <label className="text-ec-body text-[16px] font-medium">
                            Currency Format
                        </label>
                        <select
                            className="easycommerce-wizard-input w-full"
                            value={formValues.format}
                            name="payment-pricing-format"
                            onChange={handleFormatChange}
                        >
                            <option value="">Select Your Currency Format</option>
                            {Object.keys(EASYCOMMERCE.currency_format_options).map((format_option) => (
                                <option key={format_option} value={format_option}>
                                    {EASYCOMMERCE.currency_format_options[format_option]}
                                </option>
                            ))}
                        </select>
                        <p className="text-ec-placeholder text-xs">
                            Choose the currency format you want to use.
                        </p>
                    </div>

                    {/* Payment Methods */}
                    
                    <div className="flex flex-col">
                        <label className="text-ec-body text-[16px] font-medium">
                            Payment Methods
                        </label>
                        <div className="">
                            {Object.values(EASYCOMMERCE.payment_methods).map((method) => {
                                return (
                                    <div key={method.id} className="flex items-center py-5 gap-3 border-b border-ec-table-stock">
                                        <input
                                            name="payment-methods-active_methods"
                                            type="checkbox"
                                            id={method.id}
                                            value={method.id}
                                            checked={formValues.payment_methods.includes(method.id)}
                                            onChange={(e) => handlePaymentMethodToggle(e)}
                                            className="easycommerce-checkbox-input"
                                        />
                                            <label
                                            htmlFor={method.id}
                                            className="flex items-center cursor-pointer text-ec-body text-[16px]"
                                        >
                                            <span className="capitalize">{method.title}</span>
                                        </label>
                                    </div>
                                );
                            })}

                            {console.log(EASYCOMMERCE.payment_methods)}
                        </div>
                    </div>
                   
                </div>
            </div>
        </div>
    );
};

export default Payment;
